import faqs from "@/data/faq";
import { Accordion, AccordionItem } from "@heroui/react";

export default function FAQ({ list = faqs }) {

    return (
        <Accordion variant="splitted">
            {Object.keys(list).map((idx) => {
                return (
                    <AccordionItem key={idx} aria-label={list[idx].question} title={
                        <span className="font-semibold">{list[idx].question}</span>
                    }>
                        <p className="py-2"> {list[idx].answer}</p>
                    </AccordionItem>
                )
            })}
        </Accordion>
    );
}